module.exports = __webpack_public_path__ + "media/images/emblems/RoncoSopraAscona-coat_of_arms-f8d772da92549d0039d289638ee4b074.svg";